module.exports = __webpack_public_path__ + "img/sellCards.4af6a981.svg";